module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-1250-Active-Rumble-d5edb88840524164e94d25b476a9a412.png";